<ion-app>
  <ion-content #ionContentRef (ionScroll)="onScroll($event)" [scrollEvents]="true">
    <div #desktopContainerRef class="main-container" id="main-web-content">
      @if (isDesktop) {
        <div class="header-wrap ion-no-border">
          <div class="web-header">
            <div class="flex-container ion-align-items-center lft_wrp">
              <div [routerLink]="'/'" class="logo-wrap">
                <div class="web-logo"></div>
              </div>
              <div class="flex-container ion-align-items-end nav-container mob-nav">
                @if (!isCheckoutPage) {
                  <div class="nav-item" [routerLink]="['/hotels']"
                       [ngClass]="{'active': selectedMenu === 'SHORTSTAY'}">
                    <div class="flex-container ion-align-items-center">
                      <div class="nav-icon shortstay-icon"></div>
                      <div class="nav-icon-active shortstay-icon-active"></div>
                      <span class="nav-link">Hourly Stay</span>
                    </div>
                  </div>
                  <div class="nav-item"
                       [routerLink]="['/hotels-stay']"
                       [ngClass]="{'active': selectedMenu === 'EXTENDEDSTAY'}">
                    <div class="flex-container ion-align-items-center">
                      <div class="nav-icon extended-stay"></div>
                      <div class="nav-icon-active extended-stay-active"></div>
                      <span class="nav-link">Overnight Stay</span>
                    </div>
                  </div>
                  <div class="nav-item"
                       [routerLink]="['/experiences']"
                       [ngClass]="{'active': selectedMenu === 'PACKAGES'}">
                    <div class="flex-container ion-align-items-center">
                      <div class="nav-icon experiences"></div>
                      <div class="nav-icon-active experiences-active"></div>
                      <span class="nav-link">Experiences</span>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="flex-container ion-justify-content-between ion-align-items-center rht_wrp">
              @if (!isCheckoutPage) {
                <a [routerLink]="'/bag2bag-for-business'" target="_blank"
                   class="a-link header-icon"
                   (click)="analyticsService.fireAnalyticsEvent.emit({ eventName: 'list_yourproperty', data: {}})">
                  <span class="b2b_business"></span>
                  <span class="title">Bag2bag For Business</span>
                </a>
                <a [routerLink]="'/partnership/hotel-registration'" target="_blank"
                   class="a-link header-icon"
                   (click)="analyticsService.fireAnalyticsEvent.emit({ eventName: 'list_yourproperty', data: {}})">
                  <span class="list_property"></span>
                  <span class="title">List Your Property</span>
                </a>
                <!--<a
                  [href]="url"
                  target="_blank"
                  class="a-link header-icon lap-view"
                  (click)="analyticsService?.fireAnalyticsEvent.emit({ eventName: 'download_app', data: {}})">
                  <span class="download_app"></span>
                  <span class="title">Download App</span>
                </a>-->
                <a [routerLink]="'/membership'"
                   class="a-link header-icon"
                   (click)="analyticsService.fireAnalyticsEvent.emit({ eventName: 'membership', data: {}})"
                >
                  <span class="badge"></span>
                  <span class="title">Rewards</span>
                </a>
              }
              @if ((userInfo$ | async); as userInfo) {
                <app-b2b-popover-v1
                  [width]="isMobile ? '140px': '220px'"
                  [padding]="'0px'"
                  [left]="'auto'"
                  [right]="'0px'"
                  [top]="'41px'"
                  [allowContentDrop]="true">
                  <div header>
                    <div class="profile-name" id="user-popover">
                      <span class="f-nme">{{ userInfo?.firstName | titlecase }}</span>
                      <span class="avatar">{{ userInfo?.firstName?.charAt(0) }}</span>
                    </div>
                  </div>
                  <div body>
                    <div popoverContent class="user-profile-details">
                      <div class="">
                        <ul>
                          <li [routerLink]="'/user/bookings'">
                            <div class="list-name">My Bookings</div>
                          </li>
                          <li [routerLink]="'/user/wallet'">
                            <div class="list-name">My Wallet</div>
                          </li>
                          <li [routerLink]="'/user/membership-rewards'">
                            <div class="list-name">My Membership and Rewards</div>
                          </li>
                          <li [routerLink]="'/user/profile'">
                            <div class="list-name">My Profile</div>
                          </li>
                          <li [routerLink]="'/user/wishlist'">
                            <div class="list-name">My Wishlist</div>
                          </li>
                          <li [routerLink]="'/user/referrals'">
                            <div class="list-name">My Referral</div>
                          </li>
                          <li [routerLink]="'/user/coupons'">
                            <div class="list-name">My Coupons</div>
                          </li>
                          <li [routerLink]="'/user/vouchers'">
                            <div class="list-name">My Gift Card</div>
                          </li>
                          <!--<li (click)="logout();">
                            <div class="list-name">Logout</div>
                          </li>-->
                        </ul>
                      </div>
                    </div>
                  </div>
                </app-b2b-popover-v1>
              } @else {
                <div class="a-link header-icon lg-sec"
                     (click)="openLoginPopup(); analyticsService.fireAnalyticsEvent.emit({ eventName: 'login_registration', data: {}});">
                  <span class="user-img"></span>
                  <span class="title">Login / Register</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (!isDesktop) {
        <app-b2b-nav-menu></app-b2b-nav-menu>
      }

      <div #bodyContainer class="body-container">
        <router-outlet></router-outlet>
      </div>

      <!--<footer class="footer">-->
      @if (!isCheckoutPage) {
        <div class="footer-container">
          <app-b2b-desktop-footer></app-b2b-desktop-footer>
        </div>
      }
      <!--</footer>-->
    </div>
  </ion-content>

  <b2b-ripple-loader></b2b-ripple-loader>
</ion-app>
